import './style.scss';

function Skills() {

  return (
    <div className='layout' id='skills'>
      <h1 className='center-text'>Skills</h1>
      <div className='skills'>
        <h2>Programming</h2>
        <ul>
          <li>JavaScript</li>
          <li>Node.js</li>
          <li>React</li>
          <li>Java</li>
          <li>Kotlin</li>
          <li>C++</li>
          <li>C</li>
          <li>C#</li>
          <li>Python</li>
          <li>Django</li>
          <li>AWS</li>
          <li>DynamoDb</li>
          <li>SQL</li>
        </ul>
        <h2>General</h2>
        <ul>
          <li>Team Work</li>
          <li>Quick learner</li>
          <li>Problem Solving</li>
          <li>Leadership</li>
        </ul>
      </div>
    </div>
  )
}

export default Skills;